<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const DEFAULT_LOGO_THUMBNAIL = '/brand-assets/logo_thumbnail.svg';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    alt=""
    v-bind="attrs"
    :src="globalConfig.logoThumbnail || DEFAULT_LOGO_THUMBNAIL"
  />
</template>
